import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusPill } from "@/components/StatusBanner";
import { PaginationBar } from "@/components/PaginationBar";
import { WidgetError } from "@/components/WidgetError";
import { fmtDate } from "@/lib/format";

export default function CustomerHistory() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    api.get("/portal/orders", { params: { page, limit: 20 } })
       .then(({ data }) => { if (!cancelled) { setItems(data.items); setPages(data.pages); } })
       .catch((err) => { if (!cancelled) setError(err); });
    return () => { cancelled = true; };
  }, [page, reloadKey]);

  const retry = useCallback(() => setReloadKey((k) => k + 1), []);

  return (
    <div>
      <div className="mb-6">
        <div className="label-overline">Account</div>
        <h1 className="text-3xl font-black tracking-tight mt-1">Order History</h1>
      </div>
      <div className="bg-white border border-slate-200">
        {error ? (
          <div className="p-4">
            <WidgetError
              error={error}
              onRetry={retry}
              title="Could not load your history"
              testId="portal-history-error"
            />
          </div>
        ) : (
        <table className="tbl w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="label-overline text-slate-600">
              <th className="text-left px-4 py-3">Order</th>
              <th className="text-left px-4 py-3">Registration</th>
              <th className="text-left px-4 py-3">Service</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Opened</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-slate-500">No orders yet</td></tr>
            )}
            {items.map((o) => (
              <tr key={o.id} className="border-b border-slate-100">
                <td className="px-4 py-2 font-mono">
                  <Link to={`/portal/orders/${o.id}`} className="text-blue-700 hover:underline"
                        data-testid={`portal-order-${o.order_no}`}>{o.order_no}</Link>
                </td>
                <td className="px-4 py-2 font-mono">{o.registration_no}</td>
                <td className="px-4 py-2">{o.service_type_snapshot?.label}</td>
                <td className="px-4 py-2"><StatusPill status={o.status} /></td>
                <td className="px-4 py-2 font-mono text-xs">{fmtDate(o.opened_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
        <PaginationBar page={page} pages={pages} onChange={setPage} />
      </div>
    </div>
  );
}
